<template lang="pug">

.pricing-table
  .pricing-column(
    v-for="column in priceColumns"
    :key="column.id"
    :class="column.class")
    .pricing-header
      h1 {{column.title}}
      h2 {{column.subtitle}}
    .features
      .feature(
        v-for="feature in column.features") {{feature}}
    .action
      .price
        h1
          .amount {{column.price}}
          .units {{column.priceUnits}}
      button.buy-button.push-button(@click="buyPackage(column.id)" :style="{background: column.buttonColor}") {{column.buttonText}}

</template>

<script>
export default {
  data: function() {
    return {
      priceColumns: [
        {
          id: "starter",
          title: "Starter",
          subtitle: "Everything you need to get started",
          features: ["Access to Budgee", "TBA"],
          price: "$TBA",
          priceUnits: "/month",
          buttonText: "Start Now",
          buttonColor: "#3bbe8d",
          class: "elevation-3"
        },
        {
          id: "silver",
          title: "Silver",
          subtitle: "Unlock the full potential of Budgee",
          features: ["All 'Starter' Features", "TBA"],
          price: "$TBA",
          priceUnits: "/month",
          buttonText: "Feel the power",
          buttonColor: "#62949f",
          class: "elevation-3"
        },
        {
          id: "gold",
          title: "Gold",
          subtitle: "Integration options for power users",
          features: ["All 'Silver' and 'Starter' Features", "TBA"],
          price: "$TBA",
          priceUnits: "/month",
          buttonText: "Connect all the things",
          buttonColor: "#f99914",
          class: "elevation-3"
        }
      ]
    };
  },
  methods: {
    buyPackage(id) {
      console.log(id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.pricing-table
  max-width: 1000px
  width: 100%
  display: flex
  flex-direction: row
  margin: 60px auto 80px
  justify-content: space-around
  flex-wrap: wrap

.pricing-column
  width: 320px
  height: 600px
  border: 1px solid #ccc
  background: #f1f1f1
  display: flex
  overflow: hidden
  border-radius: 5px
  flex-direction: column
  margin-bottom: 20px
.features
  height: 400px
  padding: 20px
.feature
  padding: 10px 0
  //border-bottom: 1px solid #ccc
  &:before
    content: "-"
    padding: 10px
.buy-button
  width: 100%
  height: 50px
  margin-top: 20px
  border: none
  color: white
  border-radius: 5px
  font-weight: 700
.pricing-header, .action
  background: white
  padding: 20px
.amount, .units
  display: inline
.units
  font-size: 14px
h1,h2
  margin: 0
  text-align: center
h1
  font-size: 24px
  font-weight: 600
  padding: 10px 0 0
  color: rgba(0,0,0,0.7)
  line-height: 25px
h2
  font-size: 14px
  font-weight: 400
  padding: 5px
  color: rgba(0,0,0,0.57)
  max-width: 150px
  margin: 0 auto
</style>
